module.exports = __webpack_public_path__ + "static/media/icn-canceled.9c09cd15.svg";